export default "__VITE_ASSET__69HxDJk0__"